import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

/**
 * Disclaimer component
 * Displays authorization and release information with consent checkbox
 */
function Disclaimer({ consentGiven, setConsentGiven }) {
  const { t } = useTranslation();
  
  return (
    <div className="disclaimer-section">
      <h3>{t('authorizationTitle')}</h3>
      <div className="disclaimer-text">
        <p>
          {t('authorizationText')}
        </p>
      </div>
      <div className="consent-checkbox">
        <label>
          <input
            type="checkbox"
            checked={consentGiven}
            onChange={(e) => setConsentGiven(e.target.checked)}
          />
          <span>{t('consentCheckbox')}</span>
        </label>
      </div>
    </div>
  );
}

export default Disclaimer;

